// WHY: ONE rule for turning a typed Indian mobile number into the stored form
// "+91XXXXXXXXXX" (E.164). AddUser and EditUser both use it, so a technician's
// phone is always stored the way OTP login looks it up (phoneMatches() in
// firestore.rules, AuthContext's phone fallback) - LOW-13. The logic is moved
// unchanged from AddUser.jsx (D-241).

export const PHONE_ERROR = "Please enter a valid 10-digit mobile number.";

// Returns { ok, phone, empty, error }.
//   ""                -> { ok: true,  phone: "", empty: true }
//   valid 10 digits   -> { ok: true,  phone: "+91XXXXXXXXXX" }
//   anything else     -> { ok: false, phone: "", error: PHONE_ERROR }
export function normaliseIndianMobile(raw) {
  const compact = String(raw ?? "").replace(/\s+/g, "").trim();
  if (compact === "") return { ok: true, phone: "", empty: true };

  let digits = compact.replace(/\D/g, "");
  // "919876543210" -> strip the country code
  if (digits.startsWith("91") && digits.length === 12) digits = digits.slice(2);
  // "09876543210" -> strip the local-dialling 0
  if (digits.startsWith("0") && digits.length === 11) digits = digits.slice(1);

  if (digits.length !== 10) return { ok: false, phone: "", empty: false, error: PHONE_ERROR };
  return { ok: true, phone: "+91" + digits, empty: false };
}

// D-297 (commit 8a): the users doc's `whatsapp_phone` — a CONTACT-ONLY number
// for WhatsApp reminders from Team Activity. NEVER a login field: OTP login
// and firestore.rules phoneMatches() read only `phone`. Optional (any role);
// stored like `phone` (+91XXXXXXXXXX) and must be a MOBILE (starts 6–9),
// because WhatsApp needs one.
//   "" / spaces       -> { ok: true,  phone: "", empty: true }
//   valid mobile      -> { ok: true,  phone: "+91XXXXXXXXXX" }
//   anything else     -> { ok: false, phone: "", error: WHATSAPP_ERROR }
export const WHATSAPP_ERROR = "Enter a valid 10-digit mobile number for WhatsApp.";

export function normaliseWhatsAppNumber(raw) {
  const r = normaliseIndianMobile(raw);
  if (r.empty) return { ok: true, phone: "", empty: true };
  if (!r.ok || !/^\+91[6-9]\d{9}$/.test(r.phone)) {
    return { ok: false, phone: "", empty: false, error: WHATSAPP_ERROR };
  }
  return { ok: true, phone: r.phone, empty: false };
}